import React from 'react'
import { useTranslation } from 'react-i18next'
import {Typography} from 'antd'
import styles from './styles.scss'
import {
    LINK_SHARE_EMAIL_MESSAGE_PREVIEW,
    LINK_SHARE_PHONE_MESSAGE_PREVIEW
} from '@/constants/playwright-ids'

const {Text, Link} = Typography

type Props = {
    type: 'sms' | 'email'
    name: string
    url: string
    customer: string
}

export const LinkShareMessagePreview: React.FC<Props> = ({type, name, url, customer}) => {
    const { t } = useTranslation()

    const renderPreview = (type) => {
        switch (type) {
            case 'sms':
                return (
                    <div className={styles.message}>
                        <Text>{t('LinkShareMessagePreview.message', { senderName: name || 'Sender name' })}</Text>
                        <br/><br/>
                        <Link data-test-id={LINK_SHARE_PHONE_MESSAGE_PREVIEW} href={url} target="_blank" rel={'noreferrer'}>{url}</Link>
                    </div>
                )
            case 'email':
                return (
                    <div className={styles.message}>
                        <Text>
                            {t('LinkShareMessagePreview.emailMessage.greeting', { recipientName: customer })}<br/>
                            {t('LinkShareMessagePreview.emailMessage.text', { senderName: name || 'Sender name' })}
                        </Text>
                        <br/><br/>
                        <Link data-test-id={LINK_SHARE_EMAIL_MESSAGE_PREVIEW} href={url} target="_blank" rel={'noreferrer'}>{url}</Link>
                    </div>
                )
            default:
                return <></>
        }
    }

    return (
        <>
            <Text>{t('LinkShareMessagePreview.messageTextPreview')}</Text>
            {renderPreview(type)}
        </>
    )
}
